"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultFormat = void 0;
var defaultFormat = exports.defaultFormat = {
  id: 'default',
  name: '標準フォーマット',
  sheetName: 'members',
  fields: [{
    header: '所属_ID',
    internalName: 'affiliationId',
    label: '所属_ID'
  }, {
    header: '入会年',
    internalName: 'joinDate',
    label: '入会年'
  }, {
    header: '会社名',
    internalName: 'companyName',
    label: '会社名'
  }, {
    header: '会社名_ふりがな',
    internalName: 'companyNameFurigana',
    label: '会社名_ふりがな'
  }, {
    header: '会員名',
    internalName: 'fullName',
    label: '会員名'
  }, {
    header: '会員名_ふりがな',
    internalName: 'fullNameFurigana',
    label: '会員名_ふりがな'
  }, {
    header: '役職名',
    internalName: 'position',
    label: '役職名'
  }, {
    header: '郵便番号',
    internalName: 'postcode',
    label: '郵便番号'
  }, {
    header: '会社所在地',
    internalName: 'address1',
    label: '会社所在地'
  }, {
    header: 'ビル名',
    internalName: 'address2',
    label: 'ビル名'
  }, {
    header: '電話番号',
    internalName: 'phoneNumber',
    label: '電話番号'
  }, {
    header: '携帯電話',
    internalName: 'mobilePhone',
    label: '携帯電話'
  }, {
    header: 'FAX',
    internalName: 'fax',
    label: 'FAX'
  }, {
    header: 'Email',
    internalName: 'email',
    label: 'Email'
  }, {
    header: 'ホームページ',
    internalName: 'website',
    label: 'ホームページ'
  }, {
    header: '業種コード',
    internalName: 'industryCode',
    label: '業種コード'
  }, {
    header: '事業内容',
    internalName: 'businessDescriptions',
    label: '事業内容'
  }, {
    header: '設立年月日',
    internalName: 'established',
    label: '設立年月日'
  }, {
    header: '資本金',
    internalName: 'capitalStock',
    label: '資本金'
  }, {
    header: '社員数',
    internalName: 'employees',
    label: '社員数'
  }, {
    header: 'パート_アルバイト数',
    internalName: 'employeesPartTime',
    label: 'パート_アルバイト数'
  }, {
    header: '会員ID',
    internalName: 'memberId',
    label: '会員ID'
  }, {
    header: '会員パスワード',
    internalName: 'password',
    label: '会員パスワード'
  }, {
    header: '生年月日',
    internalName: 'birthday',
    label: '生年月日'
  }]
};